<template>
  <Form :app="app" />
</template>

<script>
import { mapMutations } from 'vuex'
import ModelMapper from '@/mixins/ModelMapper'
import GetAccountApps from '@/mixins/GetAccountApps'
import GetPartner from '@/mixins/GetPartner'
import Form from '@/components/apps/Form'

export default {
  components: { Form },
  computed: {
    app() {
      return this.getApps.find(app => app.name === this.name)
    }
  },
  created() {
    this.name = this.$route.params && this.$route.params.name
  },
  data() {
    return {
      name: '',
      nameModel: 'AccountApp',
    }
  },
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    disabled() {
      this.saveAccountApp(false)
    },
    enable() {
      this.saveAccountApp(true)
    },
    isContracted() {
      return !!this.activeAccountApps.some(accountApp => accountApp.appId === this.app.id)
    },
    saveAccountApp(active) {
      let accountApp = this.getAccountApps.find(a => a.appId === this.app.id) ||
        { appId: this.app.id }
      accountApp.active = active
      const message = active ? 'App ativado!' : 'App desativado'

      this.asyncTemplateSave(accountApp, {
        after: () => {
          this.loadAppsAndAccountApps()
          this.$notify.add(message)
        }
      })
    },
  },
  mixins: [ModelMapper, GetAccountApps, GetPartner],
  name: 'Show'
}
</script>

<style scoped></style>
